define('plugin/package/view/PackageClientInstanceLayout',['require','lib/view/LayoutView','plugin/package/view/PackageClientInstanceCollectionView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var PackageClientInstanceCollectionView = require('plugin/package/view/PackageClientInstanceCollectionView');

    /**
     * Package client instance layout view
     *
     * @class PackageClientInstanceLayout
     */
    return LayoutView.extend({

        template: '#package_client_instance_layout',
        regions: {
            'list': '#sb_package_client_instance_list_container'
        },

        onShow: function () {
            this.showChildView('list', new PackageClientInstanceCollectionView({
                collection: this.collection,
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection')
            }));
        }

    });

});
